module.exports = __webpack_public_path__ + "img/ContentCopyOutlined.25a33d98.svg";